import { WidgetStyleOptions } from '../interfaces/widget-style.interface';

export const DEFAULT_STYLE_OPTIONS: WidgetStyleOptions[] = [
  {
    bindTo: 'baseColor',
    label: 'Metric Color',
  }, {
    bindTo: 'backgroundColor',
    label: 'Background Color',
  }, {
    bindTo: 'textColor',
    label: 'Text Color',
  },
  {
    bindTo: 'borderWidth',
    label: 'Thickness',
  },
  {
    bindTo: 'borderColor',
    label: 'Color',
  },
  {
    bindTo: 'shadow',
    label: 'Size',
  },
  {
    bindTo: 'shadowColor',
    label: 'Color',
  },
  {
    bindTo: 'shadowOpacity',
    label: 'Opacity',
  },
  {
    bindTo: 'borderRadius',
    label: 'Corner Radius',
  },
];

export const DEFAULT_CHART_STYLE_OPTIONS: WidgetStyleOptions[] = [
  {
    bindTo: 'baseColor',
    label: 'Metric Color',
  },
  {
    bindTo: 'backgroundColor',
    label: 'Background Color',
  },
  {
    bindTo: 'textColor',
    label: 'Text Color',
  },
  {
    bindTo: 'enableColorPerChartValue',
    label: 'Enable color per value',
  },
  {
    bindTo: 'borderWidth',
    label: 'Thickness',
  },
  {
    bindTo: 'borderColor',
    label: 'Color',
  },
  {
    bindTo: 'shadow',
    label: 'Size',
  },
  {
    bindTo: 'shadowColor',
    label: 'Color',
  },
  {
    bindTo: 'shadowOpacity',
    label: 'Opacity',
  },
  {
    bindTo: 'borderRadius',
    label: 'Corner Radius',
  },
];

export const DEFAULT_OPTIONS = [
  {
    bindTo: 'title',
    label: 'Title',
    type: 'textFormat',
    options: [
      {
        bindTo: 'text',
      }, {
        bindTo: 'align',
      }, {
        bindTo: 'size',
      },
    ],
  }, {
    bindTo: 'footer',
    label: 'Footer',
    type: 'footerCheckbox',
    options: [
      {
        bindTo: 'datasetInfo',
      },
      {
        bindTo: 'dateRange',
      },
      {
        bindTo: 'comparisonDateRange',
      },
    ],
  }, {
    bindTo: 'legend',
    label: 'Legend',
    type: 'textFormat',
    options: [
      {
        bindTo: 'layout',
      }, {
        bindTo: 'position',
      }, {
        bindTo: 'align',
      }, {
        bindTo: 'size',
      },
    ],
  },
];
